import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import pinia from './store';
import { i18n } from './locales';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import jaJP from 'element-plus/es/locale/lang/ja';
import './assets/styles/reset.scss';
import './assets/styles/theme/index.scss';
import directives from './directives';
import { registerGlobalComponents } from './plugins/globalComponents';
import './utils/flexible';

const app = createApp(App);

app.use(router).use(pinia).use(i18n).use(ElementPlus, {
  locale: jaJP,
}).use(directives);

// 注册全局组件
registerGlobalComponents(app);

app.mount('#app');
